module.exports = __webpack_public_path__ + "img/20.8ccb64a5.jpg";